import { UseFormReturn } from "react-hook-form";
import { LocalFormSchema } from "../logic/applicationUpdateSchema";

const useCheckDriverLicenceNumberAgainstNames = (form: UseFormReturn<LocalFormSchema>) => {
  const errors: string[] = []

  const driverLicenceNumber = form.watch('ApplicantIdentityDetails.DriverLicenceDetails.DriverLicenceNumber')
  if (!driverLicenceNumber) {
    return errors
  }

  // Get the forename initial of the driver's name from the driver licence number
  const forenameInitial = driverLicenceNumber
    .charAt(11)
    .replace(/9/g, '')
    .toUpperCase()

  // If the forename initial is not empty, check the applicants current forename starts with the same letter
  if (forenameInitial) {
    const currentForename = form.watch('Forename')
    if (currentForename && !currentForename.toUpperCase().startsWith(forenameInitial)) {
      errors.push(`Your driver licence number contains the forename initial ${forenameInitial} but your current forename is ${currentForename}.`)
    }
  }

  // Get the start of the surname driver's name from the driver licence number
  const surnameStartsWith = driverLicenceNumber
    .substring(0, 5)
    .replace(/9/g, '')
    .toUpperCase()

  // Check the applicants current surname starts with the same letters as the driver licence number
  const currentSurname = form.watch('PresentSurname')
  if (currentSurname && !currentSurname.toUpperCase().startsWith(surnameStartsWith)) {
    errors.push(`Your driver licence number contains a surname starting with ${surnameStartsWith} but your current surname is ${currentSurname}.`)
  }

  // Get the middle initial of the driver's name from the driver licence number
  const middlenameInitial = driverLicenceNumber
    .charAt(12)
    .replace(/9/g, '')
    .toUpperCase()

  // If the middle initial is not empty, check at least one of the applicants current middle names start with the same letter
  if (middlenameInitial) {
    const currentMiddlenames = form.watch('Middlenames.Middlename')
    if (!currentMiddlenames) {
      errors.push(`Your driver licence number contains the middlename initial ${middlenameInitial} but you have not provided any middle names.`)
    } else if (!currentMiddlenames.some((name) => name.toUpperCase().startsWith(middlenameInitial))) {
      const middlenameCombined = currentMiddlenames.length === 1
        ? `middlename is ${currentMiddlenames[0]}`
        : `middle names are ${currentMiddlenames.join(' ')}`
      errors.push(`Your driver licence number contains the middlename initial ${middlenameInitial} but your ${middlenameCombined}.`)
    }
  }

  return errors
}

export default useCheckDriverLicenceNumberAgainstNames
